import React, { FunctionComponent } from 'react';
import { ContentConditions } from '../../atoms/contentConditions';

type Props = {
  title: string;
  content: string;
  conditions?: string[];
};

const fetchIdName = (title: string) => {
  if (title === '何をやるのか') {
    return 'what-to-do-section';
  } else {
    return 'desired-person-section';
  }
}

export const Presentation: FunctionComponent<Props> = ({
  title,
  content,
  conditions = [],
}) => {
  return (
    <div className="recruitment__show__content" id={fetchIdName(title)}>
      {content !== '' && (
        <>
          <h2 className="title">{title}</h2>
          <p
            dangerouslySetInnerHTML={{ __html: content }}
            className="content"
          ></p>
        </>
      )}
      <ContentConditions items={conditions} />
    </div>
  );
};
